import { render } from "./SamplesPage.vue?vue&type=template&id=3304685e&scoped=true"
import script from "./SamplesPage.vue?vue&type=script&lang=js"
export * from "./SamplesPage.vue?vue&type=script&lang=js"

import "./SamplesPage.vue?vue&type=style&index=0&id=3304685e&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3304685e"]])

export default __exports__